const Module = () => import("./Module.vue");
const ViewCustomers = () => import("./views/ViewCustomers.vue");
const AddCustomer = () => import("./views/AddCustomer.vue");
const EditCustomer = () => import("./views/EditCustomer.vue");
const ViewCustomer = () => import("./views/ViewCustomer.vue");
const ViewContracts = () => import("./views/ViewContracts.vue");
const AssignEmployees = () => import("./views/AssignEmployees.vue");
import Store from '../../store'; // Adjust the path as necessary to import your store


const moduleRoute = {
  path: "/customers",
  component: Module,
  children: [
    {
      path: "/",
      name: "customers",
      component: ViewCustomers,
      meta: {  },
      beforeEnter: (to, from, next) => {
        const permissions = Store.state.auth.permissions;
        // Check if permissions include the required permission
        const userType = Store.state.auth.userData && Store.state.auth.userData.user_type;
        // Check if permissions include the required permission
        if (userType === 'admin' || permissions.includes('nav_customers')) {
          next(); // Permission is found, continue to the route
        } else {
          next('/'); // Permission not found, redirect to another path
        }
      }
    },
    {
      path: "add",
      name: "add_customers",
      component: AddCustomer,
      meta: {  },
      beforeEnter: (to, from, next) => {
        const permissions = Store.state.auth.permissions;
        const userType = Store.state.auth.userData && Store.state.auth.userData.user_type;
        // Check if permissions include the required permission
        if (userType === 'admin' || permissions.includes('nav_customers_add')) {
          next(); // Permission is found, continue to the route
        } else {
          next('/'); // Permission not found, redirect to another path
        }
      }
    },
    {
      path: "edit/:id", // Updated to include the parameter 'id'
      name: "edit_customers",
      component: EditCustomer, // Updated to use the EditCustomer component
      meta: {  },
      beforeEnter: (to, from, next) => {
        const permissions = Store.state.auth.permissions;
        const userType = Store.state.auth.userData && Store.state.auth.userData.user_type;
        // Check if permissions include the required permission
        if (userType === 'admin' || permissions.includes('nav_customers_add')) {
          next(); // Permission is found, continue to the route
        } else {
          next('/'); // Permission not found, redirect to another path
        }
      }
    },
    {
      path: "view/:id", // Updated to include the parameter 'id'
      name: "view_customer",
      component: ViewCustomer, // Updated to use the EditCustomer component
      meta: { },
      beforeEnter: (to, from, next) => {
        const permissions = Store.state.auth.permissions;
        const userType = Store.state.auth.userData && Store.state.auth.userData.user_type;
        // Check if permissions include the required permission
        if (userType === 'admin' || permissions.includes('nav_customers')) {
          next(); // Permission is found, continue to the route
        } else {
          next('/'); // Permission not found, redirect to another path
        }
      }
    },
    {
      path: "contracts/:id?", // Updated to include the parameter 'id'
      name: "view_contracts",
      component: ViewContracts, // Updated to use the EditCustomer component
      meta: { },
      beforeEnter: (to, from, next) => {
        const permissions = Store.state.auth.permissions;
        const userType = Store.state.auth.userData && Store.state.auth.userData.user_type;
        // Check if permissions include the required permission
        if (userType === 'admin' || permissions.includes('nav_customers')) {
          next(); // Permission is found, continue to the route
        } else {
          next('/'); // Permission not found, redirect to another path
        }
      }
    },
    {
      path: "assign-employees/:id?", // Updated to include the parameter 'id' is contract detail Id
      name: "assign_employees",
      component: AssignEmployees, // Updated to use the EditEmployee component
      meta: {  },
      beforeEnter: (to, from, next) => {
        const permissions = Store.state.auth.permissions;
        const userType = Store.state.auth.userData && Store.state.auth.userData.user_type;
        // Check if permissions include the required permission
        if (userType === 'admin' || permissions.includes('nav_employees_add')) {
          next(); // Permission is found, continue to the route
        } else {
          next('/'); // Permission not found, redirect to another path
        }
      }
    },
    
  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
